export const matchPostalCodeUS = /(^\d{5}$)|(^\d{5}-\d{4}$)/
export const matchPostalCodeCA = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/
